const getPostPath = (blogPage, post) => {
  return [blogPage.slug, post.slug]
    .map((item) => {
      const withoutPostFix = item.endsWith("/") ? item.substring(0, item.length - 1) : item;
      const result = withoutPostFix.startsWith("/") ? withoutPostFix.substring(1) : withoutPostFix;
      return result;
    })
    .join("/");
};

module.exports = getPostPath;
